import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5308eb45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "header-buttons" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "profile" }
const _hoisted_6 = { class: "profile-info" }
const _hoisted_7 = { class: "orders-info" }
const _hoisted_8 = { class: "order-info" }
const _hoisted_9 = { class: "order-info" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Validar Telefone", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Aumente a integridade da sua conta", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sair", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Limpar informações do aplicativo e sair", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_with_balance = _resolveComponent("header-with-balance")!
  const _component_profile_skeleton = _resolveComponent("profile-skeleton")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_header_with_balance, {
            class: "balance-header",
            title: "Perfil",
            "has-go-back": false,
            balance: $options.cashbackValue
          }, null, 8, ["balance"]),
          _createElementVNode("div", _hoisted_1, [
            ($setup.loadingRef)
              ? (_openBlock(), _createBlock(_component_profile_skeleton, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", {
                      class: "profile-avatar-container",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.openPhoto && $options.openPhoto(...args)))
                    }, [
                      _createElementVNode("img", {
                        class: "profile-avatar",
                        src: $setup.infoRef.photoUrl || 'assets/default_user.webp'
                      }, null, 8, _hoisted_4)
                    ]),
                    (!$setup.infoRef.photoUrl)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "header-round-button clickable-component",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.openPhoto && $options.openPhoto(...args)))
                        }, [
                          _createVNode(_component_ion_icon, { icon: $setup.cameraOutline }, null, 8, ["icon"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", null, _toDisplayString($options.name), 1),
                      _createElementVNode("p", null, _toDisplayString($options.email), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString($setup.infoRef.orders_quantity || 0) + " pedidos ", 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString($setup.infoRef.ratings_count || 0) + " avaliações ", 1)
                    ])
                  ]),
                  _createVNode(_component_ion_grid, null, {
                    default: _withCtx(() => [
                      ($options.phoneVerified === 0)
                        ? (_openBlock(), _createBlock(_component_ion_row, {
                            key: 0,
                            onClick: $setup.sendCodePhone
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withCtx(() => [
                                  _hoisted_10,
                                  _hoisted_11
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.validButtons, (button) => {
                        return (_openBlock(), _createBlock(_component_ion_row, {
                          key: button.title,
                          onClick: ($event: any) => ($options.goTo(button.url))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(button.title), 1),
                                _createElementVNode("p", null, _toDisplayString(button.content), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128)),
                      _createVNode(_component_ion_row, { onClick: $setup.logoff }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withCtx(() => [
                              _hoisted_12,
                              _hoisted_13
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}